import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import StateStorage from 'lib/state-storage'
import Typo from 'constants/typography'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import CookieSetting from 'components/alert/alert-cookie/cookie-setting'
import styles from './styles.scss'
import COOKIES_SETTING_FAQ from './const'

const CookieFaqSetting = ({ t }) => {
  const [isShowSetting, setIsShowSetting] = useState(false)
  const oldCookieConsent = StateStorage.getCookie('bannerPDPACookieConsent')
  const { header, details, button } = COOKIES_SETTING_FAQ

  return (
    <div className="cookies-setting">
      <style jsx>{styles}</style>
      <div className={clsx('cookies-setting__header', Typo.title2)}>
        {hasLocizeTranslation(t, header.key, header.text)}
      </div>
      <div className={Typo.body2}>
        {hasLocizeTranslation(t, details.key, details.text)}
      </div>
      <Button type={BUTTON_TYPES.link} onClick={() => setIsShowSetting(true)}>
        {hasLocizeTranslation(t, button.key, button.text)}
      </Button>
      {isShowSetting && <CookieSetting oldCookieConsent={oldCookieConsent} />}
    </div>
  )
}

CookieFaqSetting.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withI18next()(CookieFaqSetting)
